module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "file_027"
    }
  }, [_vm._v("The navy soon ordered another version of the aircraft, which compelled Grumman’s top brass to find a larger airplane-building facility. The XSF-1 would be assembled as a scout version of basically the same machine, with more fuel capacity, aerodynamic refinements, and a slightly more powerful engine.")])]), _c('a', {
    attrs: {
      "id": "file_027"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The pair of experimental machines held the promise for many more if the navy liked what it saw, and the eight-mile move to Curtiss Field at Valley Stream, Long Island, gave Grumman more space, a ready airfield for upcoming test flights, and room to grow, should it be needed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The portly XFF-1 flew for the first time on December 29, 1931. After some taxi tests on that clear, cold morning, test pilot Bill McAvoy eased the fighter’s throttle forward and the Cyclone engine roared. The small crowd that had gathered collectively held its breath as the machine bounced along and then vaulted into the air. A cheer went up among the proud builders as their creation rumbled into the distance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But McAvoy came back much too soon. Something was wrong. After the XFF-1 touched down, they saw it: the fighter’s smooth aluminum skin and windscreen were covered in the spray of black oil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The investigation took only a second; someone had neglected to completely tighten the filler cap on the machine’s oil tank. Bill McAvoy, who could have lost his life in the crash, was only slightly annoyed. Leroy Grumman, who stood to lose everything in life besides his own life, was a bit angrier. He felt, perhaps rightly so, that one little mistake could have changed everything.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "file_027"
    }
  }, [_vm._v("The XFF-1 was a fine plane, McAvoy reported, and he was soon winging his way to Anacostia to deliver ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("the machine to the navy. It took the naval aviators about two minutes to dream up a semi-disparaging nickname for the Grumman fighter. With the bulging belly it was all too obvious. The flyers would abuse “Fertile Myrtle” for months, conducting vicious spins, rolls, dives, and stalls, hoping to find the chinks in her aluminum armor.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d65f810","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_027.vue
// module id = 132
// module chunks = 0